import { render, staticRenderFns } from "./networkDetails.vue?vue&type=template&id=f508295e&scoped=true"
import script from "./networkDetails.vue?vue&type=script&lang=js"
export * from "./networkDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f508295e",
  null
  
)

export default component.exports